




































































































































































































































































































































































































































import { Component, Vue, Prop, Model, Watch } from "vue-property-decorator";
import {
  getContactProperty,
  getContactPropertyDetail,
  getQueryVariable
} from "@/services/api";
import draggable from 'vuedraggable';
import YcColorPicker from "@/components/color-picker/index.js";
import { formTypeLabel as resolveFormTypeLabel } from '@/i18n/formPageLabel';
import { contactPropertyLabel } from '@/i18n/contactPropertyLabel';
import InfoPopover from "./InfoPopover.vue";
import EventBus from "@/utils/eventBus";
import {
  DISABLE_SMS_SUBSCRIPTION_TPLID,
  isEnableCustomFormFeatureGray,
  isEnableFlowTfnSend,
  isEnableFormSubscribeSignup,
  isOnlyNewUserTemplate
} from "@/utils/experiment";
import OptimizationHint from "@/views/wheelOfFortune/pop/optimizer/components/OptimizationHint.vue";
import { evaluateFirstStepPhone, evaluatePhonePrivacy } from "@/views/wheelOfFortune/pop/optimizer/strategies";
import { evaluatePhoneSecondStepEligibility } from "@/views/wheelOfFortune/pop/optimizer/firstStepPhone";
import { reportFormOptimizerEvent } from "@/views/wheelOfFortune/pop/optimizer/tracking";
import { guardFormOptimizerApply, RUNNING_AB_OPTIMIZER_TIP } from "@/views/wheelOfFortune/pop/optimizer/applyGuard";
import { shouldResumePhonePrivacySave } from "@/views/wheelOfFortune/pop/optimizer/phonePrivacySave";
import {
  PRIVACY_CHECK_ERROR_TIP_DEFAULT,
  PRIVACY_CHECK_REQUIRED_DEFAULT,
  SUBSCRIBE_SIGNUP_TIP_DEFAULT,
  EMBEDDED_CUSTOM_OPTION_LIMIT
} from "@/views/wheelOfFortune/constant/options";

@Component({
  components: {
    "yc-color-picker": YcColorPicker,
    InfoPopover,
    OptimizationHint,
    draggable,
  },
})
export default class componentSetForm extends Vue {
  formTypeLabel = resolveFormTypeLabel;
  contactPropertyLabel = contactPropertyLabel;

  @Prop(Object)
  setformType!: object;

  @Prop(Array)
  formList!: any;

  @Prop(Array)
  countryList!: any

  @Prop([Number, String])
  templateId!: number | string

  /** 触发类型：7 = 嵌入式表单 */
  @Prop([Number, String])
  triggerEventType!: number | string

  @Prop({ type: Object, default: () => ({}) })
  optimizerFirstStepContext!: Record<string, any>

  @Prop({ type: Boolean, default: false })
  optimizerReadOnly!: boolean

  @Prop({ type: Boolean, default: false })
  isNewFormItem!: boolean

  formType: any = {}
  // SKA2792: 固定模板锁定"必选"不可改
  @Prop({ type: Boolean, default: false })
  necessaryLocked!: boolean

  formAddList = ["Email", 'Mobile Number', 'First Name', 'Last Name', "Birthday"]
  defaultCountry = {}
  newFormList = JSON.parse(JSON.stringify(this.formList))
  companyId = JSON.parse(localStorage.getItem('companyInfo') || '{}')?.id
  necessary = true
  placeholder = ''
  List = []
  questionType = ''//单选 多选
  questionTypeList = [
    {
      id: 'Single',
      "value": this.$tx('form.singleChoice', '单选题')
    },
    {
      id: 'Multiple',
      "value": this.$tx('form.multipleChoice', '多选题')
    },
    { id: 'Date', value: this.$tx('form.set.date', '日期选择') },
    { id: 'Dropdown', value: '下拉菜单' },
  ]
  question = ""
  questionOptionList = []
  optionList = []
  redirectUrlList: string[] = []
  optionListList = []
  formatString = 'yyyy-MM-dd';
  // 是否展示第二条隐私政策外链
  showSecondPrivacyLink: boolean = false;
  initialEnablePrivacyCheck = false;
  phonePrivacyRecommendationDismissed = false;
  phonePrivacySavePending = false;
  phonePrivacyImpressionReported = false;
  firstStepPhoneRecommendationDismissed = false;
  firstStepPhoneImpressionReported = false;
  optimizerReadOnlyTip = RUNNING_AB_OPTIMIZER_TIP;
  endButtonRedirectHelpLines = [
    '仅在表单结束页主按钮点击时生效，不会在当前步骤立即跳转。',
    '结束页主按钮需设置为“打开指定链接”。',
    '同一弹窗最多启用一道单选题。'
  ];


  get isDisableSmartCollect() {
    const templateId = String(this.templateId || getQueryVariable('templateid') || '');
    return [193].includes(Number(templateId));
  }

  get isDropdownUnsupportedTemplate() {
    const templateId = String(this.templateId || getQueryVariable('templateid') || '');
    return ['1', '18'].includes(templateId);
  }

  get filteredQuestionTypeList() {
    // 下拉菜单题型仅对命中扩展灰度的店铺开放，且排除不支持的老模板（1/18）
    if (!isEnableCustomFormFeatureGray() || this.isDropdownUnsupportedTemplate) {
      return this.questionTypeList.filter((item) => item.id !== 'Dropdown');
    }
    return this.questionTypeList;
  }

  get enablePrivacyShow() {
    return this.formType.enablePrivacyShow !== false;
  }

  get enablePrivacySetting() {
    return sessionStorage.getItem('popType') !== 'WheelOfFortune';
  }

  get enableMultiPrivacyLinks() {
    return sessionStorage.getItem('popType') !== 'WheelOfFortune';
  }

  get showSetCheckbox() {
    return sessionStorage.getItem('popType') === 'POP_WINDOW';
  }

  get showEndButtonRedirectSetting() {
    return this.formType.questionType === 'Single' && this.supportsEndButtonAnswerRedirect;
  }

  get supportsEndButtonAnswerRedirect() {
    return sessionStorage.getItem('popType') === 'POP_WINDOW' &&
      Number(this.triggerEventType) !== 7;
  }

  handleEndButtonRedirectChange(enabled: boolean) {
    if (!enabled) {
      return;
    }
    const request = {
      question: this.setformType,
      allowed: true,
      conflictLabel: ''
    };
    EventBus.$emit('end-button-redirect-enable-request', request);
    if (!request.allowed) {
      this.$set(this.formType, 'endButtonRedirectEnabled', false);
      const questionTip = request.conflictLabel ? `“${request.conflictLabel}”` : this.$tx('form.set.otherSingleChoice', '其他单选题');
      this.$message.warning(this.$tx('form.set.jumpConflictCloseFirst', '{{tip}}已开启按答案跳转，请先关闭后再开启当前题', { tip: questionTip }));
    }
  }

  get enableCollectWay() {
    const templateId = String(this.templateId || getQueryVariable('templateid') || '');
    // 新订阅用户发放券包、大转盘模板、嵌入式表单、多步骤采集模板不进行本次功能新增
    return isEnableFlowTfnSend() &&
      !DISABLE_SMS_SUBSCRIPTION_TPLID.includes(templateId) &&
      sessionStorage.getItem('popType') === 'POP_WINDOW';
  }

  get enablePhoneForm() {
    return this.formType.collectWay !== 'smart';
  }

  // SKA2792: 固定模板锁定 Email/Mobile Number 必填不可改
  get isContactRequiredLocked() {
    return this.necessaryLocked && ['Email', 'Mobile Number'].includes(this.formType.type);
  }

  get enableFormSubscribeSignup() {
    const templateId = String(this.templateId || getQueryVariable('templateid') || '');
    return isEnableFormSubscribeSignup() && ![44].includes(Number(templateId));
  }

  // 仅指定公司可配置"隐私勾选必填设置"
  get showPrivacyRequiredSetting() {
    return true;
  }

  get showFormRepeatSignup() {
    return JSON.parse(localStorage.getItem('companyInfo') || '{}').formRepeatSignup;
  }

  get hasSecondPrivacyLink() {
    return !!(this.formType?.link2Text || this.formType?.privacyPolicyLink2);
  }

  get isOnlyNewUserTemplate() {
    const templateId = String(this.templateId || getQueryVariable('templateid') || '');
    return isOnlyNewUserTemplate(templateId);
  }

  get lockPrivacyCheckRequired() {
    return this.isOnlyNewUserTemplate && this.formType.enablePrivacyCheck;
  }

  get phonePrivacyRecommendation() {
    if (this.lockPrivacyCheckRequired) return null;
    return evaluatePhonePrivacy(this.formType);
  }

  get firstStepPhoneRecommendation() {
    if (!this.isNewFormItem
      || this.formType?.type !== 'Mobile Number') return null;
    const eligibility = evaluatePhoneSecondStepEligibility({
      ...this.optimizerFirstStepContext,
      isNewPhoneField: this.isNewFormItem,
      startFields: this.formList,
      phoneField: this.formType,
    } as any);
    if (!eligibility.eligible) return null;
    return evaluateFirstStepPhone({ start: [...this.formList, this.formType] }, false);
  }

  get showFirstStepPhoneRecommendation() {
    return !!this.firstStepPhoneRecommendation && !this.firstStepPhoneRecommendationDismissed;
  }

  reportFirstStepPhoneImpression() {
    const recommendation = this.firstStepPhoneRecommendation;
    if (!recommendation || this.firstStepPhoneImpressionReported) return;
    this.firstStepPhoneImpressionReported = true;
    reportFormOptimizerEvent('form_optimizer_recommendation_impression', recommendation.strategyId, recommendation.evidenceVersion);
  }

  applyFirstStepPhoneRecommendation() {
    const recommendation = this.firstStepPhoneRecommendation;
    if (!recommendation) return;
    if (!guardFormOptimizerApply(this.optimizerReadOnly, message => this.$message.warning(message))) return;
    const request = {
      phoneField: JSON.parse(JSON.stringify(this.formType)),
      applied: false,
    };
    EventBus.$emit('form-optimizer-split-phone-step', request);
    if (!request.applied) {
      this.$message.error(this.$tx('form.set.err.adjustFailed', '暂时无法完成调整，原配置未发生变化'));
      return;
    }
    this.firstStepPhoneRecommendationDismissed = true;
    this.$emit('close', false);
  }

  dismissFirstStepPhoneRecommendation() {
    const recommendation = this.firstStepPhoneRecommendation;
    if (!recommendation) return;
    this.firstStepPhoneRecommendationDismissed = true;
    reportFormOptimizerEvent('form_optimizer_recommendation_dismissed', recommendation.strategyId, recommendation.evidenceVersion);
  }

  get phonePrivacyRiskActive() {
    return !!this.phonePrivacyRecommendation;
  }

  get showPhonePrivacyRecommendation() {
    return this.phonePrivacyRiskActive && !this.phonePrivacyRecommendationDismissed;
  }

  reportPhonePrivacyImpression() {
    const recommendation = this.phonePrivacyRecommendation;
    if (!recommendation || this.phonePrivacyImpressionReported) return;
    this.phonePrivacyImpressionReported = true;
    reportFormOptimizerEvent(
      'form_optimizer_recommendation_impression',
      recommendation.strategyId,
      recommendation.evidenceVersion
    );
  }

  /**
   * 仅恢复由手机号隐私诊断暂缓的保存。
   * 非保存场景下主动点击建议仍只做局部修改，不会意外关闭手机号设置浮层。
   */
  resumePendingPhonePrivacySave(shouldResume: boolean) {
    this.phonePrivacySavePending = false;
    if (!shouldResume) return;
    this.$nextTick(() => this.save());
  }

  applyPhonePrivacyRecommendation() {
    const recommendation = this.phonePrivacyRecommendation;
    if (!recommendation) return;
    if (!guardFormOptimizerApply(this.optimizerReadOnly, message => this.$message.warning(message))) return;
    const shouldResumeSave = shouldResumePhonePrivacySave(this.phonePrivacySavePending, 'apply');
    const scrollContainer = (this.$el as HTMLElement)?.querySelector('.setForm') as HTMLElement | null;
    const scrollTop = scrollContainer?.scrollTop || 0;
    this.$set(this.formType, 'privacyCheckRequired', '1');
    this.phonePrivacyRecommendationDismissed = true;
    reportFormOptimizerEvent(
      'form_optimizer_recommendation_applied',
      recommendation.strategyId,
      recommendation.evidenceVersion,
      { changed_field_keys: ['privacyCheckRequired'] }
    );
    this.resumePendingPhonePrivacySave(shouldResumeSave);
    if (shouldResumeSave) return;
    // 非保存触发的建议仅局部更新当前字段；提示收起后恢复右侧面板滚动位置。
    this.$nextTick(() => {
      if (scrollContainer) scrollContainer.scrollTop = scrollTop;
    });
  }

  dismissPhonePrivacyRecommendation() {
    const recommendation = this.phonePrivacyRecommendation;
    if (!recommendation) return;
    this.phonePrivacyRecommendationDismissed = true;
    reportFormOptimizerEvent(
      'form_optimizer_recommendation_dismissed',
      recommendation.strategyId,
      recommendation.evidenceVersion
    );
    // 暂不调整/关闭只取消本次待保存动作，保留风险配置并停留在手机号设置浮层。
    this.phonePrivacySavePending = false;
  }

  filterQuestionOptionList(questionType: string) {
    return this.questionOptionList.filter(item => item.valueType === (questionType === 'Date' ? 3 : 0));
  }

  /**
   * 端隐私勾选必填设置默认值归一化：
   * - 存量模板可能出现 privacyCheckRequired 为 boolean（true/false）
   * - 新模板使用 string（0/1）
   */
  normalizePrivacyCheckDefaults() {
    // privacyCheckRequired
    if (this.formType.privacyCheckRequired === undefined || this.formType.privacyCheckRequired === null) {
      this.$set(this.formType, 'privacyCheckRequired', this.isOnlyNewUserTemplate ? '1' : PRIVACY_CHECK_REQUIRED_DEFAULT);
    } else if (
      this.formType.privacyCheckRequired === true ||
      this.formType.privacyCheckRequired === 1 ||
      this.formType.privacyCheckRequired === '1' ||
      this.formType.privacyCheckRequired === 'required'
    ) {
      this.$set(this.formType, 'privacyCheckRequired', '1');
    } else if (
      this.formType.privacyCheckRequired === false ||
      this.formType.privacyCheckRequired === 0 ||
      this.formType.privacyCheckRequired === '0' ||
      this.formType.privacyCheckRequired === 'optional'
    ) {
      this.$set(this.formType, 'privacyCheckRequired', PRIVACY_CHECK_REQUIRED_DEFAULT);
    } else if (!['0', '1'].includes(String(this.formType.privacyCheckRequired))) {
      this.$set(this.formType, 'privacyCheckRequired', this.isOnlyNewUserTemplate ? '1' : PRIVACY_CHECK_REQUIRED_DEFAULT);
    }

    // privacyCheckErrorTip
    if (this.formType.privacyCheckErrorTip === undefined || this.formType.privacyCheckErrorTip === null) {
      this.$set(this.formType, 'privacyCheckErrorTip', PRIVACY_CHECK_ERROR_TIP_DEFAULT);
    }
  }

  normalizeSubscribeSignupDefaults() {
    if (this.formType.formSubscribeSignup === undefined || this.formType.formSubscribeSignup === null) {
      this.$set(this.formType, 'formSubscribeSignup', false);
    }
    if (!this.formType.tipSubscribeEmailText) {
      this.$set(this.formType, 'tipSubscribeEmailText', SUBSCRIBE_SIGNUP_TIP_DEFAULT);
    }
    if (!this.formType.tipSubscribePhoneText) {
      this.$set(this.formType, 'tipSubscribePhoneText', SUBSCRIBE_SIGNUP_TIP_DEFAULT);
    }
  }

  async created(): Promise<void> {
    this.init()
    this.getContactProperty()
  }
  init() {
    this.formType = JSON.parse(JSON.stringify(this.setformType))
    this.normalizeLockedNecessary();
    // console.log(this.formType,'this.formType!!!!')
    if (!this.formType.collectWay) {
      this.$set(this.formType, 'collectWay', 'traditional');
    }
    // 日期格式适配
    if (this.formType.formatString) {
      this.formatString = this.formType.formatString;
    } else {
      this.formType.formatString = this.formatString;
    }
    // 初始化第二条隐私政策外链展示状态（兼容已有数据）
    this.showSecondPrivacyLink = !!(this.formType.link2Text || this.formType.privacyPolicyLink2);
    this.initialEnablePrivacyCheck = !!this.formType.enablePrivacyCheck;
    // console.log('form init', JSON.stringify(this.formType));
    this.defaultCountry['countryAbbreviation'] = this.formType.phoneCountryAbbreviation;
    this.defaultCountry['phoneCode'] = this.formType.phoneCode;
    // 初始化重复提交提示默认值
    if (!this.formType.tipRepeatEmailText) {
      this.$set(this.formType, 'tipRepeatEmailText', 'email already used.');
    }
    if (!this.formType.tipRepeatPhoneText) {
      this.$set(this.formType, 'tipRepeatPhoneText', 'phone already used.');
    }
    this.normalizeSubscribeSignupDefaults();
    // 初始化端隐私勾选必填设置默认值（存量数据兼容）
    this.normalizePrivacyCheckDefaults();
    // 初始化下拉菜单占位文案默认值
    if (this.formType.questionType === 'Dropdown' && !this.formType.placeholder) {
      this.$set(this.formType, 'placeholder', 'Please select');
    }
    if (this.formType.type === '自定义') {
      let optionList = []
      for (let i = 0; i < this.setformType.optionList.length; i++) {
        optionList.push(this.setformType.optionList[i].value);
      }
      if (!optionList[0]) {
        optionList = ['', '']
      }
      this.optionList = optionList
      this.redirectUrlList = (this.setformType.optionList || []).map((option: any) => option.endButtonRedirectUrl || '')
      while (this.redirectUrlList.length < optionList.length) {
        this.redirectUrlList.push('')
      }

      this.getContactPropertyDetail(this.formType.attributeId);
    }
  }

    // SKA2792: 固定模板——强制锁定字段的 necessary 为 true
  normalizeLockedNecessary() {
    if (this.isContactRequiredLocked && this.formType.necessary !== true) {
      this.$set(this.formType, 'necessary', true);
    }
  }

  changeAttribute(item: any) {
    this.newFormList.forEach((i: any) => {
      if (i.attribute === item) {
        this.$message.error(this.$tx('form.edit.err.dupField', '您添加了多个{{label}}表单，请检查设置是否有误', { label: i.label }))
        this.formType.attribute = ''
        return
      }
    })
    let id = this.questionOptionList.filter((item) => {
      if (item.name == this.formType.attribute) {
        return item
      }
    })
    if (id[0]?.id && !id[0].routine) {
      this.formType.attributeId = id[0]?.id;
      this.formatString = id[0]?.formatString;
      this.formType.formatString = id[0]?.formatString;
      this.getContactPropertyDetail(id[0]?.id)
    } else {
      this.formType.attributeId = null;
      this.optionListList = []
    }
  }

  async getContactProperty() {
    let { data, status } = await getContactProperty({}, false)
    if (status == 200) {
      this.questionOptionList = data.data;
    }
  }

  changeCountryCode(country) {
    this.formType.phoneCode = country.phoneCode;
    this.formType.phoneCountryAbbreviation = country.countryAbbreviation;
  }

  changeFormatString(val) {
    this.formType.formatString = val;
  }

  async getContactPropertyDetail(id: number) {
    if (id) {
      let { data, status } = await getContactPropertyDetail({
        propertyId: id
      }, false)
      if (status == 200) {
        this.optionListList = data.data.valueList;
      }
    } else {
      this.optionListList = []
    }
  }

  getCompanyId() {
    const company = JSON.parse(localStorage.getItem('companyInfo') || '{}');
    return company?.id;
  }

  save() {
    this.normalizeLockedNecessary();

    if (this.lockPrivacyCheckRequired) {
      this.$set(this.formType, 'privacyCheckRequired', '1');
    }
    // console.log('befere save:', JSON.stringify(this.formType));
    // 邮箱校验提示
    if (this.formType.type === 'Email') {
      if (!this.formType.tipInvalidEmailText) {
        this.$message.error(this.$tx('form.set.err.needErrorTip', '请完善错误信息提示'));
        return
      }
      if (!this.formType.tipEmptyEmailText && this.formType.necessary) {
        this.$message.error(this.$tx('form.set.err.needRequiredTip', '请完善必选信息提示'));
        return
      }
      if (this.formType.formRepeatSignup && !this.formType.tipRepeatEmailText) {
        this.$message.error(this.$tx('form.set.err.needRepeatEmail', '请完善邮箱-重复提交提示'));
        return;
      }
      if (this.formType.formSubscribeSignup && !String(this.formType.tipSubscribeEmailText || '').trim()) {
        this.$message.error(this.$tx('form.set.err.needSubscribeTip', '请完善已订阅用户提交提示'));
        return;
      }
      if (this.formType.enablePrivacyShow) {
        if (!this.formType.text) {
          this.$message.error(this.$tx('form.set.err.needPolicyText', '请完善政策文本'));
          return;
        }
        // 第一条外链（必填）
        if (!this.formType.linkText) {
          this.$message.error(this.$tx('form.set.err.needPrivacyText', '请完善隐私政策链接文案'));
          return;
        }
        if (!this.formType.privacyPolicyLink) {
          this.$message.error(this.$tx('form.set.err.needPrivacyLink', '请完善隐私链接'));
          return;
        }
        // 第二条外链：只要添加了就做校验
        if (this.showSecondPrivacyLink) {
          if (!this.formType.link2Text) {
            this.$message.error(this.$tx('form.set.err.needPrivacyText', '请完善隐私政策链接文案'));
            return;
          }
          if (!this.formType.privacyPolicyLink2) {
            this.$message.error(this.$tx('form.set.err.needPrivacyLink', '请完善隐私链接'));
            return;
          }
          if (!this.formType.joinText || !this.formType.joinText.trim()) {
            this.$message.error(this.$tx('form.set.err.needJoinText', '请完善隐私政策链接间连接文字'));
            return;
          }
        }
        // 端隐私勾选必填校验（仅当开启了勾选框且配置为必填）
        if (
          this.formType.enablePrivacyCheck &&
          String(this.formType.privacyCheckRequired) === '1' &&
          (!this.formType.privacyCheckErrorTip || !String(this.formType.privacyCheckErrorTip).trim())
        ) {
          this.$message.error(this.$tx('form.set.err.needUncheckedTip', '请完善未勾选错误提示'));
          return;
        }
      }
    }
    // 手机号校验提示
    if (this.formType.type === 'Mobile Number') {
      if (!this.formType.tipEmptyPhoneText && this.formType.necessary) {
        this.$message.error(this.$tx('form.set.err.needRequiredTip', '请完善必选信息提示'));
        return
      }
      if (!this.formType.tipInvalidPhoneText) {
        this.$message.error(this.$tx('form.set.err.needErrorTip', '请完善错误信息提示'));
        return
      }
      if (this.formType.formRepeatSignup && !this.formType.tipRepeatPhoneText) {
        this.$message.error(this.$tx('form.set.err.needRepeatPhone', '请完善手机号-重复提交提示'));
        return;
      }
      if (this.formType.formSubscribeSignup && !String(this.formType.tipSubscribePhoneText || '').trim()) {
        this.$message.error(this.$tx('form.set.err.needSubscribeTip', '请完善已订阅用户提交提示'));
        return;
      }
      if (!this.formType.text) {
        this.$message.error(this.$tx('form.set.err.needPolicyText', '请完善政策文本'));
        return
      }
      // 第一条外链（必填）
      if (!this.formType.linkText) {
        this.$message.error(this.$tx('form.set.err.needPrivacyText', '请完善隐私政策链接文案'));
        return
      }
      if (!this.formType.privacyPolicyLink) {
        this.$message.error(this.$tx('form.set.err.needPrivacyLink', '请完善隐私链接'));
        return
      }
      // 第二条外链：只要添加了就做校验
      if (this.showSecondPrivacyLink) {
        if (!this.formType.link2Text) {
          this.$message.error(this.$tx('form.set.err.needPrivacyText', '请完善隐私政策链接文案'));
          return;
        }
        if (!this.formType.privacyPolicyLink2) {
          this.$message.error(this.$tx('form.set.err.needPrivacyLink', '请完善隐私链接'));
          return;
        }
        if (!this.formType.joinText || !this.formType.joinText.trim()) {
          this.$message.error(this.$tx('form.set.err.needJoinText', '请完善隐私政策链接间连接文字'));
          return;
        }
      }
      // 端隐私勾选必填校验（仅当开启了勾选框且配置为必填）
      if (
        this.formType.enablePrivacyCheck &&
        String(this.formType.privacyCheckRequired) === '1' &&
        (!this.formType.privacyCheckErrorTip || !String(this.formType.privacyCheckErrorTip).trim())
      ) {
        this.$message.error(this.$tx('form.set.err.needUncheckedTip', '请完善未勾选错误提示'));
        return;
      }
    }
    //校验相关属性
    if (this.formType.type === '自定义') {
      if (!this.formType.attribute) {
        this.$message.error(this.$tx('form.set.err.needAttr', '请选择相关属性'));
        this.$nextTick(() => {
          const attributeEl: any = this.$refs.attribute;
          attributeEl.focus();
        })
        return
      }
      if (!this.formType.questionType) {
        this.$message.error(this.$tx('form.set.err.needQuestionKind', '请选择单选或者多选或者日期'));
        this.$nextTick(() => {
          const questionTypeEl: any = this.$refs.questionType;
          questionTypeEl.focus();
        })
        return
      }
      if (this.showEndButtonRedirectSetting && this.formType.endButtonRedirectEnabled) {
        const redirectUrls = this.redirectUrlList.map((url: string) => (url || '').trim()).filter(Boolean);
        if (!redirectUrls.length) {
          this.$message.error(this.$tx('form.set.err.needRedirect', '请至少配置一个选项跳转链接'));
          return;
        }
        const hasInvalidUrl = redirectUrls.some((url: string) => {
          try {
            const parsedUrl = new URL(url);
            return !['http:', 'https:'].includes(parsedUrl.protocol) || !parsedUrl.hostname;
          } catch (error) {
            return true;
          }
        });
        if (hasInvalidUrl) {
          this.$message.error(this.$tx('form.set.err.redirectHttp', '选项跳转链接需填写完整的 http:// 或 https:// 地址'));
          return;
        }
      }
      let hash = {}

      let id = this.questionOptionList.filter((item) => {
        if (item.name == this.formType.attribute) {
          return item
        }
      })
      if (id[0]) {
        this.formType.attributeId = id[0].id;
        this.formType.routine = id[0].routine;
      } else {
        this.formType.attributeId = null
        this.formType.routine = false
      }

      let newOptionList = []
      if (this.formType.questionType === 'Date') {
        if (!this.formType.question) {
          this.$message.error(this.$tx('form.set.err.optionEmpty', '有选项未设置，请设置后重新保存'));
          return
        }
      } else {
        for (let i = 0; i < this.optionList.length; i++) {
          if (!this.optionList[i]) {
            // console.log(hash)
            this.$message.error(this.$tx('form.set.err.optionEmpty', '有选项未设置，请设置后重新保存'));
            return
          }
          let newObj = this.optionListList.filter((item) => {
            if (item.value == this.optionList[i]) {
              return item
            }
          })
          if (newObj[0]) {
            newOptionList.push({
              ...newObj[0],
              endButtonRedirectUrl: (this.redirectUrlList[i] || '').trim()
            })
            if (hash[newObj[0].value]) {
              this.$message.error(this.$tx('form.set.err.optionDup', '不可设置相同的选项，请修改后重新保存'));
              return
            }
            hash[newObj[0].value] = true
          } else {
            newOptionList.push({
              value: this.optionList[i],
              endButtonRedirectUrl: (this.redirectUrlList[i] || '').trim()
            })
            if (hash[this.optionList[i]]) {
              this.$message.error(this.$tx('form.set.err.optionDup', '不可设置相同的选项，请修改后重新保存'));
              return
            }
            hash[this.optionList[i]] = true
          }
        }
      }

      if (!this.supportsEndButtonAnswerRedirect) {
        this.$delete(this.formType, 'endButtonRedirectEnabled');
        newOptionList = newOptionList.map(({ endButtonRedirectUrl, ...option }: any) => option);
      }

      if (this.formType.questionType === 'Date') {
        if (id[0]) {
          this.formType.label = id[0].label;
        } else {
          this.formType.label = this.formType.attribute;
        }
        this.formType.valueType = 3;
      } else {
        this.formType.label = this.formType.attribute
      }
      this.formType.optionList = newOptionList;
      // 下拉菜单占位文案为空时回退默认值
      if (this.formType.questionType === 'Dropdown' && !this.formType.placeholder) {
        this.formType.placeholder = 'Please select';
      }
    }

    // “点击保存”指手机号字段设置弹窗底部保存：风险配置先暂缓，用户处理建议后自动恢复本次保存。
    if (this.phonePrivacyRiskActive && !this.phonePrivacyRecommendationDismissed) {
      this.phonePrivacySavePending = true;
      this.reportPhonePrivacyImpression();
      return;
    }
    // console.log('after save: ', JSON.stringify(this.formType));
    this.$emit('changFormItem', this.formType)
    this.$emit('close', false)
  }

  close() {
    this.$emit('close', false)
  }

  changeStartWithGtag(key: string, name: string) {
    window?.gtagClick(key, name);
  }

  handleSubscribeSignupTracking(enabled: boolean) {
    if (!enabled) {
      return;
    }
    const formType = this.formType.type;
    if (formType === 'Email') {
      window?.gtagClick('form_edit_selectField_EmailSubDedup', '弹窗_编辑订阅工具_选择采集项_邮箱_提交订阅去重');
    } else if (formType === 'Mobile Number') {
      window?.gtagClick('form_edit_selectField_PNSubDedup', '弹窗_编辑订阅工具_选择采集项_电话号码_提交订阅去重');
    }
  }

  optionPlaceholder(index: number) {
    return this.$tx('form.set.optionN', '选项+ {{n}}', { n: index + 1 });
  }
  questionTypeLabel(item: any) {
    const map: Record<string, string> = {
      Single: 'form.set.single',
      Multiple: 'form.set.multiple',
      Date: 'form.set.date',
      Dropdown: 'form.set.dropdown',
    };
    return this.$tx(map[item.id] || item.id, item.value);
  }
  creatOption() {
    // 嵌入式表单（triggerEventType === 7）：单选/多选/下拉每题选项上限 8 个
    if (Number(this.triggerEventType) === 7) {
      if (this.optionList.length < EMBEDDED_CUSTOM_OPTION_LIMIT) {
        this.optionList.push('')
        this.redirectUrlList.push('')
      } else {
        this.$message.error(this.$tx('form.set.err.optionCapEmbedded', "单个问题选项已达上限（{{n}} 个）。如选项较多，建议改用'下拉'题型，更省空间。", { n: EMBEDDED_CUSTOM_OPTION_LIMIT }));
      }
      return;
    }
    const maxOptions = this.formType.questionType === 'Dropdown' ? 20 : 10;
    if (this.optionList.length < maxOptions) {
      this.optionList.push('')
      this.redirectUrlList.push('')
    } else {
      this.$message.error(this.$tx('form.set.err.optionMax', '选项最多只能有{{n}}个', { n: maxOptions }));
    }
  }
  changeOptionList(index: number) {
    if (this.optionList[index].length > 50) {
      this.optionList[index] = this.optionList[index].substring(0, 50)
      this.$message.error(this.$tx('form.set.err.max50', '最多为50个字符'));
    }
  }
  delOption(index: number) {
    this.optionList.splice(index, 1)
    this.redirectUrlList.splice(index, 1)
  }
  @Watch('setformType')
  setformTypeWatch(val: any) {
    this.formType = JSON.parse(JSON.stringify(this.setformType))
    this.phonePrivacyRecommendationDismissed = false;
    this.phonePrivacySavePending = false;
    this.phonePrivacyImpressionReported = false;
    const options = this.formType.optionList || [];
    this.optionList = options.map((option: any) => typeof option === 'string' ? option : option.value);
    this.redirectUrlList = options.map((option: any) => typeof option === 'string' ? '' : (option.endButtonRedirectUrl || ''));
    this.normalizeLockedNecessary();
    // 初始化重复提交提示默认值
    if (!this.formType.collectWay) {
      this.$set(this.formType, 'collectWay', 'traditional');
    }
    if (!this.formType.tipRepeatEmailText) {
      this.$set(this.formType, 'tipRepeatEmailText', 'email already used.');
    }
    if (!this.formType.tipRepeatPhoneText) {
      this.$set(this.formType, 'tipRepeatPhoneText', 'phone already used.');
    }
    this.normalizeSubscribeSignupDefaults();
    // 同步第二条隐私政策外链展示状态
    this.showSecondPrivacyLink = !!(this.formType.link2Text || this.formType.privacyPolicyLink2);
    this.initialEnablePrivacyCheck = !!this.formType.enablePrivacyCheck;

    // 初始化端隐私勾选必填设置默认值（存量数据兼容）
    this.normalizePrivacyCheckDefaults();
  }
  @Watch('setformType.optionList')
  optionListWatch(val: any) {
    this.optionList = (val || []).map((option: any) => typeof option === 'string' ? option : option.value)
    this.redirectUrlList = (val || []).map((option: any) => typeof option === 'string' ? '' : (option.endButtonRedirectUrl || ''))
  }
  @Watch('formType.attribute')
  attributeWatch(val: any, old: any) {
    if (typeof (val) === 'undefined') {
      return
    }
    if (typeof (old) === 'undefined') {
      return
    }
    this.formType.question = ''
    this.optionList = ['', '']
    this.redirectUrlList = ['', '']
  }
  @Watch('formType.questionType')
  questionTypeWatch(val: any, old: any) {
    if (typeof (val) === 'undefined') {
      return
    }
    if (typeof (old) === 'undefined') {
      return
    }
    this.formType.attribute = ''
    this.formType.question = ''
    this.optionList = ['', '']
    this.redirectUrlList = ['', '']
    if (val !== 'Single') {
      this.$set(this.formType, 'endButtonRedirectEnabled', false);
    }
    if (val === 'Dropdown') {
      this.$set(this.formType, 'placeholder', 'Please select');
    }
  }
  @Watch('formType.enablePrivacyCheck')
  enablePrivacyCheckWatch() {
    if (this.lockPrivacyCheckRequired && !this.initialEnablePrivacyCheck) {
      this.$set(this.formType, 'privacyCheckRequired', '1');
    }
  }
  @Watch('phonePrivacyRiskActive', { immediate: true })
  phonePrivacyRiskWatch(active: boolean, previous: boolean) {
    if (active && !previous) {
      this.phonePrivacyRecommendationDismissed = false;
      this.phonePrivacyImpressionReported = false;
      this.$nextTick(() => this.reportPhonePrivacyImpression());
    }
    if (!active) {
      this.phonePrivacySavePending = false;
      this.phonePrivacyImpressionReported = false;
    }
  }
  @Watch('firstStepPhoneRecommendation', { immediate: true })
  firstStepPhoneRecommendationWatch(value: any, previous: any) {
    if (value && !previous) {
      this.firstStepPhoneRecommendationDismissed = false;
      this.firstStepPhoneImpressionReported = false;
      this.$nextTick(() => this.reportFirstStepPhoneImpression());
    }
    if (!value) this.firstStepPhoneImpressionReported = false;
  }
  // 新增第二条隐私政策外链
  addSecondPrivacyLink() {
    if (this.showSecondPrivacyLink) {
      return;
    }
    this.showSecondPrivacyLink = true;
    // if (!this.formType.link2Text) {
    //   this.$set(this.formType, 'link2Text', 'privacy policy');
    // }
    // if (typeof this.formType.privacyPolicyLink2 === 'undefined') {
    //   this.$set(this.formType, 'privacyPolicyLink2', '');
    // }
    if (!this.formType.joinText) {
      this.$set(this.formType, 'joinText', 'and');
    }
  }
  // 删除第一条外链：如果存在第二条，则将第二条迁移为第一条；否则仅清空第一条
  removeFirstPrivacyLink() {
    if (this.showSecondPrivacyLink) {
      this.formType.linkText = this.formType.link2Text;
      this.formType.privacyPolicyLink = this.formType.privacyPolicyLink2;
      this.formType.link2Text = '';
      this.formType.privacyPolicyLink2 = '';
      this.showSecondPrivacyLink = false;
    } else {
      this.formType.linkText = '';
      this.formType.privacyPolicyLink = '';
    }
  }
  // 删除第二条外链：仅清空第二条并隐藏卡片
  removeSecondPrivacyLink() {
    this.formType.link2Text = '';
    this.formType.privacyPolicyLink2 = '';
    this.showSecondPrivacyLink = false;
  }
}
